import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "ma-wrapper flex-col flex-align-center" }
const _hoisted_2 = { class: "ma-cal" }
const _hoisted_3 = { class: "ma-month flex-row flex-justify-sb" }
const _hoisted_4 = { class: "fw-bold" }
const _hoisted_5 = {
  class: "ma-cal-grid",
  id: "calHeaders"
}
const _hoisted_6 = {
  class: "ma-cal-grid",
  id: "calGrid"
}
const _hoisted_7 = ["disabled", "onClick"]
const _hoisted_8 = { class: "fw-bold" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  key: 1,
  class: "blur-price"
}
const _hoisted_11 = { key: 2 }
const _hoisted_12 = { key: 3 }
const _hoisted_13 = { key: 4 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_currency = _resolveComponent("currency")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          class: "month-btn flex-center",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.setMonth(-1)), ["stop"]))
        }, _cache[2] || (_cache[2] = [
          _createElementVNode("div", null, null, -1)
        ])),
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.monthName), 1),
        _createElementVNode("button", {
          class: "month-btn flex-center",
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.setMonth(1)), ["stop"]))
        }, _cache[3] || (_cache[3] = [
          _createElementVNode("div", null, null, -1)
        ]))
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.weekdays, (d, i) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "ma-cal-day flex-center flex-align-end",
            key: i
          }, _toDisplayString(d), 1))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.calendar, (day) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "ma-cal-day flex-center",
            key: day.date
          }, [
            _createElementVNode("button", {
              class: _normalizeClass(["cal-day-btn flex-col flex-align-center flex-justify-center", { 'in-month': day.inMonth, available: day.available, closed: day.closed, 'sold-out': day.soldOut, selected: day.selected }]),
              disabled: day.disabled,
              onClick: _withModifiers(($event: any) => (_ctx.$emit('onSelect', day.date)), ["stop"])
            }, [
              _createElementVNode("span", _hoisted_8, _toDisplayString(day.number), 1),
              (!day.inMonth || _ctx.isLargeGroup)
                ? (_openBlock(), _createElementBlock("span", _hoisted_9, " "))
                : (_ctx.loadingMonth)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_10, "null"))
                  : (day.soldOut)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, "Sold Out"))
                    : (day.price != 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                          _createVNode(_component_currency, {
                            amount: day.price
                          }, null, 8, ["amount"])
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_13, " "))
            ], 10, _hoisted_7)
          ]))
        }), 128))
      ])
    ])
  ]))
}